import axios from 'axios'
import moment from 'moment'

import { CarehomeDto } from "../dto/CarehomeDto";
import { WardDto } from "../dto/WardDto";
import { PatientDto } from "../dto/PatientDto";
import { DrugDto } from "../dto/DrugDto";
import { ReorderOptionDto } from "../dto/ReorderOptionDto";
import { WardCycleDto, PatientOrderItemDto, MedProfileDto, UserDto, PermissionTypeDto, EMARResult, CarehomeDispensationStatus, MedRoundDto, DispensationItemDto } from "../dto/Dtos";

import { OrderStatus } from "./../dto/OrderStatusEnum"
import BaseDal from './BaseDal';
import { LogEntry } from '../Tracking/AppDatabase';


interface WeatherForecast {
    dateFormatted: string;
    temperatureC: number;
    temperatureF: number;
    summary: string;
}

export default class Dal extends BaseDal {

    //private HandleError(error: any) {
    //    if (error.response.status == 401) {
    //        // Start the Authoization flow
    //        return false;
    //    }

    //    return false;
    //}

    //private async Get<T>(url: string) {
    //    var response =  await axios.get(url);
    //    var items = response.data as T;
    //    return items;
    //}


    //private async Put<T>(url: string, data: T) {
    //    console.log("Axios PUT " + url, data);
    //    return axios.put(url, data, {
    //        headers: {
    //            'Content-Type': 'application/json'
    //        }
    //    })
    //        .then(reponse => {
    //            return true;
    //        }).catch(error => {
    //            return this.HandleError(error)
    //        });
    //}

    //private async Post<T>(url: string, data: T) {
    //    return axios.post(url, data, {
    //        headers: {
    //            'Content-Type': 'application/json'
    //        }
    //    })
    //        .then(reponse => {
    //            return true;
    //        }).catch(error => {
    //            return this.HandleError(error)
    //        });
    //}

    public async GetApiServer(): Promise<any> {
        var response = await axios.get("/ApiServer");
        console.log(response.data);
        return response.data;
    }

    public async RemoteLog(items: LogEntry[]): Promise<any> {
        //Do not bubble logging errors 
        return this.Post("/api/v1/log/entries", { entries : items}).catch(e => {
            console.log("Error Logging To server ", e);
        })
    }

    public async GetUser(): Promise<UserDto> {
        return this.Get<UserDto>("/api/User/GetUserByToken");
    }
    public async GetValues() {
        return  this.Get<Array<WeatherForecast>>("/api/SampleData/WeatherForecasts");
    }

    public async GetPharmacyPermissionTypes(): Promise<Array<PermissionTypeDto>> {
        var result = new Array<PermissionTypeDto>();
        result.push(new PermissionTypeDto(2, "UnitAdmin"));
        result.push(new PermissionTypeDto(4, "UnitUser"));
        return  Promise.resolve<Array<PermissionTypeDto>>(result);
    }
    public async GetPermissionTypes() {

        var result = new Array<PermissionTypeDto>();
        result.push(new PermissionTypeDto(0, "SysAdmin"));
        result.push(new PermissionTypeDto(1, "AccountAdmin"));
        result.push(new PermissionTypeDto(2, "UnitAdmin"));
        result.push(new PermissionTypeDto(3, "CarehomeAdmin"));
        result.push(new PermissionTypeDto(4, "UnitUser"));
        result.push(new PermissionTypeDto(5, "CarehomeUser"));

        return  Promise.resolve<Array<PermissionTypeDto>>(result);

    }


    public async GetUnitUsers() {

        return  this.Get<Array<UserDto>>("/api/user/GetUsersForUnit");
    }

    public async GetUsers() {
        return  this.Get<Array<UserDto>>("/api/user/GetUsersForCarehome");
    }

    public async CreateUser(dto: UserDto): Promise<any> {
        var url = "/api/user/create";
        return this.Post(url, dto);
    }

    public async GetUsersForCarehome(carehomeId?: string) {
        var url = "/api/user/GetUsersForCarehome";
        if (carehomeId) {
            url += "?carehomeId=" + carehomeId;
        }
        return  this.Get<Array<UserDto>>(url);
    }

    public async GetCarehomes() {
        return  this.Get<Array<CarehomeDto>>("/api/carehome");
    }

    public async GetCarehome(id: string) {
        return  this.Get<CarehomeDto>("/api/carehome?carehomeId=" + id);
    }

    public async GetWards(carehomeId: string) {
        return  this.Get<WardDto>("/api/ward/get?carehomeId=" + carehomeId);
    }

    public async GetPatients(carehomeId: string) {
        return  this.Get<Array<PatientDto>>("/api/carehomepatient?carehomeId=" + carehomeId);
    }

    public async GetPatient(patientId: string) {
        return  this.Get<Array<PatientDto>>("/api/carehomepatient?patientId=" + patientId).then(data => {
            return data[0];
        });
    }

    public async GetMedRounds(patientId: string): Promise<Array<MedRoundDto>> {
        var result = new Array<MedRoundDto>();
        return Promise.resolve(result);
    }

    public async GetMedProfile(patientId: string, startDate: Date, endDate: Date): Promise<Array<MedProfileDto>> {
        var sd = moment(startDate).format('YYYY-MM-DD');
        var ed = moment(endDate).format('YYYY-MM-DD');
        return  this.Get<Array<MedProfileDto>>("/api/MedProfile?patientId=" + patientId + "&startDate=" + sd + "&endDate=" + ed);
    }

    public async SaveMedProfile(patientId: string, startDate: Date, endDate: Date, items: Array<MedProfileDto>): Promise<any> {
        var sd = moment(startDate).format('YYYY-MM-DD');
        var ed = moment(endDate).format('YYYY-MM-DD');
        var url = "/api/MedProfile?patientId=" + patientId + "&startDate=" + sd + "&endDate=" + ed;
        
        return  this.Post(url, items);
    }
    public async GetWardCycles(wardId: string): Promise<Array<WardCycleDto>> {
        return  this.Get<Array<WardCycleDto>>("/api/WardCycle?wardId=" + wardId);
    }


    public async UpdateDispensationItems(patientId: string, startDate: Date, endDate: Date, items: Array<DispensationItemDto>): Promise<any> {
        var sd = moment(startDate).format('YYYY-MM-DD');
        var ed = moment(endDate).format('YYYY-MM-DD');
        var url = "/api/DispensationItem?patientId=" + patientId + "&startDate=" + sd + "&endDate=" + ed + "&unitId=" + "uuuuuu"
        return this.Post(url, items);
    }

    public async GetDispensationItems(patientId: string, startDate: Date, endDate: Date): Promise<Array<DispensationItemDto>> {
        var sd = moment(startDate).format('YYYY-MM-DD');
        var ed = moment(endDate).format('YYYY-MM-DD');
        return this.Get<Array<any>>("/api/DispensationItem?patientId=" + patientId + "&startDate=" + sd + "&endDate=" + ed);
    }

    public async GetPatientOrders(patientId: string, startDate: Date, endDate: Date): Promise<Array<PatientOrderItemDto>> {
        var sd = moment(startDate).format('YYYY-MM-DD');
        var ed = moment(endDate).format('YYYY-MM-DD');
        return  this.Get<Array<PatientOrderItemDto>>("/api/CarehomePatientOrderItem?patientId=" + patientId + "&startDate=" + sd + "&endDate=" + ed);
    }

    public async SavePatientOrders(patientId: string, startDate: Date, endDate: Date, orders: Array<PatientOrderItemDto>): Promise<any> {
        var sd = moment(startDate).format('YYYY-MM-DD');
        var ed = moment(endDate).format('YYYY-MM-DD');
        var url = "/api/CarehomePatientOrderItem?patientId=" + patientId + "&startDate=" + sd + "&endDate=" + ed;

        return  this.Post(url, orders);
    }


    public async CreatePatient(carehomeId: string, patient: PatientDto) {
        console.log("Creating Patient");
        console.log(patient);
        var url = "/api/CarehomePatient";
        this.Post(url, patient);
    }

    public async UpdatePatient(patient: PatientDto) {
        console.log("Updating Patient");
        console.log(patient);
        var url = "/api/CarehomePatient";
        this.Put(url, patient);

    }

    public async SearchDrug(terms: string) {
        console.log("Searching for drugs : " + terms)
        return  this.Get<DrugDto>("/api/drug/" + terms);
    }


    public GetReorderOptions(): Array<OrderStatus> {
        return OrderStatus.GetList();
    }

    public async GetDispensationPatients(date: Date, carehomeId: string): Promise<Array<PatientDto>> {
        var formattedDate = moment(date).format('YYYY-MM-DD');
        //console.log("GetDispensationPatients", date, formattedDate);
        var url = "api/DispensationItemMAR/GetEMARPatients?marDate=" + formattedDate + "&carehomeId=" + carehomeId;
        return  this.Get<Array<PatientDto>>(url);
    }

    //public async WaitForChanges(carehomeId: string, time: number): Promise<CarehomeDispensationStatus> {

    //    console.log("Getting changes where time > " + time);
    //    var url = "/api/DispensationItemMAR/GetCarehomeDrugRoundAdminDetails?carehomeId=" + carehomeId + "&time=" + time;
    //    return  this.Get<CarehomeDispensationStatus>(url);
    //}

    public async GetCarehomeStatus(carehomeId: string): Promise<CarehomeDispensationStatus> {
        
        var url = "/api/DispensationItemMAR/GetCarehomeDrugRoundAdminDetails?carehomeId=" + carehomeId 
        return  this.Get<CarehomeDispensationStatus>(url);
    }

    public async GetDispensationMar(date: Date, patientId: string): Promise<EMARResult> {
        var formattedDate = moment(date).format('YYYY-MM-DD');

        //console.log("GetDispensationMar", date, formattedDate);
        var url = "/api/DispensationItemMAR/GetEMARDetailsForAPatient?marDate=" + formattedDate + "&pharmacyPatientId=" + patientId;
        return  this.Get<EMARResult>(url);
    }


    public async GenerateReports(patientids: Array<string>, charts: Array<string>, startDate: Date, endDate: Date) {
        var url = "/api/ReportData?";
        var first = 0;
        for (var chart of charts) {

            url += (first++ == 0 ? "" : "&") + "selectedReports=" + chart;
        }

        var sd = moment(startDate).format('YYYY-MM-DD');
        var ed = moment(endDate).format('YYYY-MM-DD');

        var body = {
            "StartDate": sd,
            "EndDate": ed,
            "ReportPatientIds": patientids,
        }
        console.log(url);
        console.log(JSON.stringify(body));


        var axiosPromise = axios.post(url, JSON.stringify(body), {
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: 'blob', // important
        })

        return axiosPromise.then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.pdf');
            document.body.appendChild(link);
            link.click();
            return true;
        })
            .catch(error => {
                console.error("Could not download Charts", error)
            });


        //return  this.Post(url, JSON.stringify(body));
    }
}


// WEBPACK FOOTER //
// ./ClientApp/scripts/dataaccess.ts